import React from 'react'
import { IconProps } from './icons.models'

export const RoundApproveIcon = ({
    width = 16,
    height = 16,
    className,
    onClick,
    fillColor = '#009966'
}: IconProps) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <g clipPath="url(#clip0_558_3076)">
                <path d="M7.99967 14.6654C11.6816 14.6654 14.6663 11.6806 14.6663 7.9987C14.6663 4.3168 11.6816 1.33203 7.99967 1.33203C4.31778 1.33203 1.33301 4.3168 1.33301 7.9987C1.33301 11.6806 4.31778 14.6654 7.99967 14.6654Z" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 8.0013L7.33333 9.33464L10 6.66797" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_558_3076">
                    <rect width={16} height={16} fill="white" />
                </clipPath>
            </defs>
        </svg>


    )
}
